import { render, staticRenderFns } from "./AutocompleteView.vue?vue&type=template&id=52e9634f&scoped=true&"
import script from "./AutocompleteView.vue?vue&type=script&lang=js&"
export * from "./AutocompleteView.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteView.vue?vue&type=style&index=0&id=52e9634f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9634f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
